<section class="bg-gray-50 dark:bg-gray-900 py-4 sm:py-5">
	<div class="px-4 lg:px-12">
		<div class="table-container mat-elevation-z0 border border-solid border-gray-400">
			<div class="table-header" fxLayout="row">
				<div class="advanced-filters-pill">
					<button [disableRipple]="true" mat-flat-button color="accent" (click)="advancedFilter()" style="min-width: 100px; height: 30px; padding: 0px">
						<fa-icon mat-flat-button icon="sliders-h" style="margin-right: 5px; font-size: 12px; color: var(--portals-theme-primary)"></fa-icon>
						{{ 'Filter (' + filters.length + ')' }}
					</button>
					<mat-chip-list *ngIf="filters.length != 0">
						<mat-chip
							*ngFor="let filter of filters; let i = index"
							color="accent"
							[ngStyle]="{
								color: app == 'Y-Stop' ? 'var(--portals-theme-accent)' : 'var(--portals-theme-primary)',
								background: filter.parameter.key !== 'user' ? (app == 'Y-Stop' ? 'var(--portals-theme-primary)' : 'var(--portals-theme-accent)') : '#98d5dd'
							}"
							[selected]="true"
							(removed)="removeFilter(i)"
						>
							{{ filter.parameter.text }}
							<strong *ngIf="filter.parameter.key !== 'user'" style="margin: 0 4px">
								{{ filter.condition | lowercase }}
							</strong>
							{{ filter.parameter.key !== 'user' ? getFilterChipLabel(filter) : '' }}
							<button [disableRipple]="true" matChipRemove mat-icon>
								<mat-icon [style.color]="'var(--portals-theme-primary'">cancel</mat-icon>
							</button>
						</mat-chip>
					</mat-chip-list>
				</div>

				<!-- <div class="search-input" fxFlex="20">
		      <mat-icon *ngIf="searchFilter">search</mat-icon>
		      <input
		        #input
		        type="search"
		        *ngIf="searchFilter"
		        name="search"
		        [placeholder]="searchPlaceholder"
		        id="search"
		        (keyup)="applyFilter($event)"
		      />
		    </div> -->

				<div class="action-buttons" fxFlex>
					<div *ngIf="viewToggle">
						<button [disableRipple]="true" *ngIf="!viewAll" mat-flat-button (click)="dataChange.emit()" color="primary">
							<span>{{ toggleAllText }}</span>
						</button>
						<button [disableRipple]="true" *ngIf="viewAll" mat-flat-button (click)="dataChange.emit()" color="primary">
							<span>{{ toggleFilterText }}</span>
						</button>
					</div>
					<button [disableRipple]="true" *ngIf="sortable" mat-flat-button (click)="sortItemsOrder.emit()" color="primary" class="pr-2 pl-2 mr-2">
						<span>{{ sortTableText }}</span>
						<mat-icon>sort</mat-icon>
					</button>
					<!--					<button-->
					<!--						[disableRipple]="true"-->
					<!--						mat-flat-button-->
					<!--						color="accent"-->
					<!--						(click)="advancedFilter()"-->
					<!--						style="min-width: 100px; height: 30px; padding: 0px"-->
					<!--					>-->
					<!--						<fa-icon-->
					<!--							mat-flat-button-->
					<!--							icon="sliders-h"-->
					<!--							style="-->
					<!--								margin-right: 5px;-->
					<!--								font-size: 12px;-->
					<!--								color: var(&#45;&#45;portals-theme-primary);-->
					<!--							"-->
					<!--						></fa-icon>-->
					<!--						{{ 'Filter (' + filters.length + ')' }}-->
					<!--					</button>-->
					<button [disableRipple]="true" [tourAnchor]="createNewTourAnchorID" *ngIf="addItemEnabled" mat-icon-button (click)="addItemPressed.emit()" class="add-new" style="color: var(--portals-theme-primary-button)">
						<span class="mr-1">Add New</span>
						<mat-icon>add_circle</mat-icon>
					</button>
					<button [disableRipple]="true" *ngIf="renameItemEnabled" mat-icon-button (click)="renameItemPressed.emit()" style="color: var(--portals-theme-primary-button)">
						<span>Edit</span>
						<mat-icon [ngStyle]="{ 'font-size': '18px' }">edit</mat-icon>
					</button>
					<button [disableRipple]="true" mat-icon-button *ngIf="exportable" [matMenuTriggerFor]="menu" style="color: var(--portals-theme-primary-button)">
						<mat-icon>more_vert</mat-icon>
					</button>
					<mat-menu #menu="matMenu" color="primary">
						<button [disableRipple]="true" mat-menu-item (click)="exportData()">Export</button>

						<button [disableRipple]="true" mat-menu-item (click)="genReport()" *ngIf="generateReport">Generate Report</button>
					</mat-menu>
				</div>
			</div>

			<portals-loading [showIf]="tableLoading || pageLoading">
				<div class="mat-table-container">
					<!--					<ngx-loading [show]="pageLoading" [config]="loaderConfig"></ngx-loading>-->
					<table mat-table [dataSource]="filteredData.length > 0 ? filteredDataSource : dataSource" matSort (matSortChange)="sortData($event)">
						<!-- Checkbox Column -->
						<ng-container matColumnDef="select">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef>
								<mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null; selectRow()" [checked]="selection.isSelected(row)"></mat-checkbox>
							</td>
						</ng-container>

						<!-- Thumbnail column -->
						<ng-container matColumnDef="thumbnail">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let row" class="text-center">
								<portals-avatar _shape="rectangle" [centered]="true" [imageUrl]="row | thumbnail : 'small' | async"></portals-avatar>
							</td>
						</ng-container>

						<ng-container *ngFor="let item of columns; let i = index" [matColumnDef]="item.key">
							<th
								mat-header-cell
								class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
								*matHeaderCellDef
								mat-sort-header
								[ngClass]="item.alignment || 'left'"
								[disabled]="!item.sortable ? true : false || unorderedList == false"
								[ngStyle]="{
									width: !item?.columnWidth ? 'auto' : item?.columnWidth
								}"
							>
								{{ item.text }}
							</th>
							<td mat-cell *matCellDef="let row" [ngClass]="item.alignment || 'left'">
								<div [ngSwitch]="item.type">
									<ng-container *ngSwitchCase="'avatar-circle'">
										<portals-avatar _shape="circle" [imageUrl]="(row | object : item.key) || '/assets/images/jotto-yellow.png' || 'assets/images/image-thumb.png'"></portals-avatar>
									</ng-container>
									<ng-container *ngSwitchCase="'avatar-rectangle'">
										<portals-avatar _shape="rectangle" [imageUrl]="(row | object : item.key) || 'assets/images/image-thumb.png'"></portals-avatar>
									</ng-container>
									<div *ngSwitchCase="'collectible_type'" class="collectible_type">
										<portals-collectible-type [value]="row | object : item.key"></portals-collectible-type>
									</div>
									<div *ngSwitchCase="'seen'" class="seen">
										<portals-icon-toggle [value]="row | object : item.key" [onColor]="'#00a000'" [offColor]="'#e4e4e4'" onIcon="eye" offIcon="eye"></portals-icon-toggle>
									</div>
									<div *ngSwitchCase="'transcription'">
										<div *ngIf="row | object : item.key">
											<portals-intakes-transcription-row [data]="row"></portals-intakes-transcription-row>
										</div>
									</div>
									<div *ngSwitchCase="'flag'" class="flag">
										<portals-icon-toggle [value]="row | object : item.key" [onColor]="'#ec3c54'" [offColor]="'#e4e4e4'" onIcon="flag" offIcon="flag"></portals-icon-toggle>
									</div>
									<!-- <div *ngSwitchCase="'active'" class="active">
						  <portals-icon-toggle
							[value]="row | object: item.key"
							[onColor]="'#00a000'"
							[offColor]="'#d11919'"
							onIcon="check"
							offIcon="xmark"
						  >
						  </portals-icon-toggle>
						</div> -->
									<div *ngSwitchDefault>
										{{ !((row | object : item.key) === null || (row | object : item.key) === undefined) ? (row | object : item.key | dynamic : _pipes[item.pipe || ''] : item.pipeArgs) : ('' | dynamic : _pipes[item.pipe || ''] : item.pipeArgs) || '-' }}
									</div>
								</div>
							</td>
						</ng-container>

						<!-- Tags Column -->
						<ng-container matColumnDef="tagsField">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef>Tags</th>
							<td mat-cell *matCellDef="let row">
								<mat-chip-list>
									<mat-chip color="primary" selected *ngFor="let tag of row.tags">
										{{ tag.name }}
									</mat-chip>
								</mat-chip-list>
							</td>
						</ng-container>

						<!-- Active/Inactive Status Column -->
						<ng-container matColumnDef="is_active">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef mat-sort-header>Status</th>
							<td mat-cell *matCellDef="let row">
								<div class="status-column-wrapper">
									<div class="status-dot" [style.background]="row.is_active ? 'var(--portals-theme-status-live-light) 0% 0% no-repeat padding-box' : 'var(--portals-theme-status-expired-light) 0% 0% no-repeat padding-box'" [style.border]="row.is_active ? '1px solid var(--portals-theme-status-live)' : '1px solid var(--portals-theme-status-expired)'" selected></div>
									<label class="status-label" for="status">
										{{ row.is_active ? 'ACTIVE' : 'INACTIVE' }}
									</label>
								</div>
							</td>
						</ng-container>

						<!-- Status Column -->
						<ng-container matColumnDef="scheduledStatusField">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef mat-sort-header>Status</th>
							<td mat-cell *matCellDef="let row">
								<div class="status-column-wrapper" *ngIf="row.state">
									<div
										class="status-dot"
										[ngStyle]="
											(row | status) == 'LIVE'
												? {
														background: 'var(--portals-theme-status-live-light) 0% 0% no-repeat padding-box',
														border: '1px solid var(--portals-theme-status-live)'
												  }
												: (row | status) == 'DRAFT'
												? {
														background: 'var(--portals-theme-status-draft-light) 0% 0% no-repeat padding-box',
														border: '1px solid var(--portals-theme-status-draft)'
												  }
												: (row | status) == 'PENDING'
												? {
														background: 'var(--portals-theme-status-pending-light) 0% 0% no-repeat padding-box',
														border: '1px solid var(--portals-theme-status-pending)'
												  }
												: (row | status) == 'EXPIRED'
												? {
														background: 'var(--portals-theme-status-expired-light) 0% 0% no-repeat padding-box',
														border: '1px solid var(--portals-theme-status-expired)'
												  }
												: (row | status) == 'ARCHIVED'
												? {
														background: 'var(--portals-theme-status-archived-light) 0% 0% no-repeat padding-box',
														border: '1px solid var(--portals-theme-status-archived)'
												  }
												: {}
										"
										selected
									></div>
									<label class="status-label" for="status">
										{{ row | status }}
									</label>
								</div>
							</td>
						</ng-container>

						<!-- Event Link Column -->
						<ng-container matColumnDef="externalLink">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
								<button [disableRipple]="true" mat-button>
									<mat-icon color="primary" (click)="externalLink.emit(row)">link</mat-icon>
								</button>
							</td>
						</ng-container>

						<!-- Share Link Column -->
						<ng-container matColumnDef="share">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
								<button [disableRipple]="true" mat-button>
									<mat-icon (click)="sharedRow.emit(row)">ios_share</mat-icon>
								</button>
							</td>
						</ng-container>

						<!-- Edit Button Column -->
						<ng-container matColumnDef="edit">
							<th mat-header-cell class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
								<button [disableRipple]="true" mat-button>
									<mat-icon (click)="editingRow.emit(row)">edit</mat-icon>
								</button>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-headers"></tr>
						<tr
							mat-row
							(click)="rowSelected.emit(row); highlight(i); selectRow(row)"
							[ngClass]="{
								highlight: selectedRowIndex == i,
								active: selectedRowIndex == i
							}"
							[class.selected]="row.id === selectedRow?.id"
							[tourAnchor]="'tableData' + dataSource.filteredData.indexOf(row)"
							(keydown.arrowdown)="arrowDownEvent(selectedRowIndex + 1)"
							(keydown.arrowup)="arrowUpEvent(selectedRowIndex - 1)"
							(keydown.enter)="rowSelected.emit(highlightedRow)"
							(mouseenter)="(selectedRowIndex == i); highlight(i)"
							(mouseleave)="(selectedRowIndex == i); highlight(i)"
							*matRowDef="let row; columns: displayedColumns; let i = index"
						></tr>

						<!-- Row shown when there is no matching data. -->
						<tr [tourAnchor]="dataSource.filteredData.length == 0 ? 'tableData0' : ''" class="mat-row text-center" *matNoDataRow>
							<td class="mat-cell text-center w-full" colspan="12">
								<!--							<svg class="w-10 h-10 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40">-->
								<!--								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>-->
								<!--							</svg>-->
								Sorry! There are no {{ title | lowercase }} available at the moment
							</td>
						</tr>
					</table>
				</div>
			</portals-loading>
		</div>

		<div class="paginator">
			<ng-container *ngIf="totalRows === -1; else elseBlock">
				<mat-paginator [pageSizeOptions]="pageSizeOptions" aria-label="Select page"></mat-paginator>
			</ng-container>

			<ng-template #elseBlock>
				<div class="paginator-content">
					<div class="pag-box">
						<span class="control-label mr-2 text-xs">Items per page:</span>
						<div class="select-container">
							<select [(ngModel)]="pageSize" (ngModelChange)="pageChanged()" id="paginator" class="page-selector flex items-center justify-center w-full px-2 py-0.5 text-xs font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
								>
								<option [value]="page" *ngFor="let page of pageSizeOptions" [selected]="page === pageSize">
									{{ page }}
								</option>
							</select>
						</div>
					</div>
					<div class="pag-box">
						<button [disableRipple]="true" mat-icon-button id="previous" type="button" aria-label="Next page" (click)="previousPage()" [disabled]="isPreviousDisabled()" [ngClass]="{ 'disabled-action': isPreviousDisabled() }">
							<svg class="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
								<path d="M8.766.566A2 2 0 0 0 6.586 1L1 6.586a2 2 0 0 0 0 2.828L6.586 15A2 2 0 0 0 10 13.586V2.414A2 2 0 0 0 8.766.566Z" />
							</svg>
						</button>
						<span class="entry-label text-xs">{{ getStartEntry() }} - {{ getEndEntry() }} of {{ totalRows }}</span>
						<button [disableRipple]="true" mat-icon-button id="next" type="button" aria-label="Next page" (click)="nextPage()" [disabled]="isNextDisabled()" [ngClass]="{ 'disabled-action': isNextDisabled() }">
							<svg class="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
								<path d="M3.414 1A2 2 0 0 0 0 2.414v11.172A2 2 0 0 0 3.414 15L9 9.414a2 2 0 0 0 0-2.828L3.414 1Z" />
							</svg>
						</button>
					</div>
				</div>
			</ng-template>
		</div>
	</div>
</section>
